var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"authentication-redirect-countdown"},[_vm._v("\n  Você será redirecionado para pesquisa em "+_vm._s(_vm.secondsRemaining)+" segundos.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }